import { useState, useEffect } from 'react';
import { Button, Snackbar, Alert } from '@mui/material';
import DownloadOutlined from '@ant-design/icons/DownloadOutlined';

export default function InstallPWA() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstall, setShowInstall] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstall(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;

    console.log(`Resultado da instalação: ${outcome}`);
    setDeferredPrompt(null);
    setShowInstall(false);
  };

  const handleClose = () => {
    setShowInstall(false);
  };

  return (
    <Snackbar
      open={showInstall}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      autoHideDuration={10000}
    >
      <Alert
        severity="info"
        action={
          <Button color="inherit" size="small" onClick={handleInstall} startIcon={<DownloadOutlined />}>
            Instalar
          </Button>
        }
        onClose={handleClose}
        sx={{ width: '100%', maxWidth: 400 }}
      >
        Instale o app na tela inicial para acesso rápido!
      </Alert>
    </Snackbar>
  );
}
